import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'
import Button from '@material-ui/core/Button'
import { withRouter } from 'react-router-dom'

class OrderRestriction extends Component {
  render() {
    return (
      <div>
        <Typography variant="h6" component="div">Order Cannot Be Returned or Exchanged</Typography>
        <p>We apologize, but this is a final sale item and is not eligible for return or exchange.</p>
        <p>If you have any questions, please contact our customer service department. <Link url="tel://866-712-7808">866-712-7808</Link></p>
        <Button color="primary" variant="contained" onClick={() => this.props.history.replace('/pages/' + this.props.pageName)}>Try Again</Button>
      </div>
    )
  }
}

export default withRouter(OrderRestriction)
